import React, {useEffect, useState} from 'react'
import PropTypes from 'prop-types'
import _ from "lodash";
import {ModalStyled} from "./styled";
// Import directo: varias molecules importan este organism y el barrel crearía un ciclo
import ActionDialog from "../../molecules/action-dialog";
import {PencilLine} from "lucide-react";
import Select from "react-select";
import {veloraSelectStyles} from "../../../config/react-select-styles";
import { veloraSelectComponents } from '../../../config/react-select-components'
import TextField from "@material-ui/core/TextField";
import DateFnsUtils from '@date-io/date-fns'
import esLocale from 'date-fns/locale/es'
import { MuiPickersUtilsProvider, KeyboardDatePicker, KeyboardDateTimePicker } from '@material-ui/pickers'
import { Calendar } from 'lucide-react'
import { tokens } from '../../../assets/tokens'
import {updateCandidature} from "../../../api";
import {toast} from "react-toastify";
import {manageQueriesWithPrefix, refetchQueriesByKeys} from "../../../api/mutations/mutationCallbacks";
import {MODULES, QUERY_ACTIONS, QUERY_KEYS} from "../../../config/constants";
import {useAppContext} from "../../../context/appContext";
import { FeatureGuard } from '../../../utils/guard';
import moment from 'moment';
import { isJSON } from "../../../utils/validation";
import { jsonToShow } from "../../../utils/formatting";
import {useParams} from "react-router";

const EditFieldAction = ({i18n, profile, client, clientColor, updateProfileField, remoteName, defaultValue, phase = null, allowEdit = true}) => {
  const {module} = useAppContext();
  const {job_offer_application_id, slug} = useParams();
  const [showPopup, setShowPopup] = useState(false);
  const [isEditable, setIsEditable] = useState(false);
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [fieldLabel, setFieldLabel] = useState('');
  const [value, setValue] = useState(null);
  const [options, setOptions] = useState([]);
  const [formData, setFormData] = useState({});

  const getInputType = (remoteName) => {
    let dateFieldsPattern = ['_date'];
    let timeFieldsPattern = ['_time'];
    let dateTimeFieldsPattern = ['_at'];

    if (dateFieldsPattern.some(pattern => remoteName.endsWith(pattern))) {
      return 'date';
    } else if (timeFieldsPattern.some(pattern => remoteName.endsWith(pattern))) {
      return 'time';
    } else if (dateTimeFieldsPattern.some(pattern => remoteName.endsWith(pattern))) {
      return 'datetime-local';
    }
    return 'text';
  };

  useEffect(() => {
    let editableFields = null;
    if (profile && phase) {
      editableFields = profile.editable_fields[phase];
    } else if (profile) {
      editableFields = profile.editable_fields;
    }

    if(!editableFields || !FeatureGuard.canAccessToEditableFields()) return setIsEditable(false);

    if (typeof editableFields == 'object' && !Array.isArray(editableFields)) {
      editableFields = [editableFields];
    }

    let editableFieldData = _.find(editableFields, {remote_name: remoteName});
    if (editableFieldData) {
      setFormData({
        dni: profile.dni,
        [phase ? 'onboarding_id' : 'candidature_id']: profile.id,
        candidatura_seleccionada_id: profile.candidatura_id,
        editingFieldData: {
          [phase ? 'onboardingId' : 'candidatureId']: profile.id,
          fieldName: editableFieldData.name,
          oldValue: editableFieldData.value,
          value: value,
        }
      });
      setIsEditable(true);
      setFieldLabel(editableFieldData.name);
      setValue(editableFieldData.value);
      let editableOptions = editableFieldData.options;

      editableOptions = editableOptions.sort(function (a, b) {
        if (!isNaN(a.value) && !isNaN(b.value)) {
          let valueA = +a.value;
          let valueB = +b.value;

          return valueA > valueB ? 1 : -1;
        }
        return a.value.localeCompare(b.value);
      });
      if (editableOptions.length > 0 && !_.find(editableOptions, {label: i18n.editFieldAction.empty})) {
        editableOptions.unshift({label: i18n.editFieldAction.empty, value: ''});
      }
      setOptions(editableOptions);
    } else {
      setIsEditable(false);
    }
  }, []);

  const handleOpenPopup = () => setShowPopup(true);
  const handleClosePopup = () => setShowPopup(false);

  // Fecha (y hora) para el selector. Se guardan como las mandaba el input nativo:
  // YYYY-MM-DD en los campos de fecha y YYYY-MM-DDTHH:mm en los de fecha y hora
  const isDateTimeField = getInputType(remoteName) === 'datetime-local';
  const outputFormat = isDateTimeField ? 'YYYY-MM-DDTHH:mm' : 'YYYY-MM-DD';
  const [dateValue, setDateValue] = useState(null);
  useEffect(() => {
    if (!value) return setDateValue(null);
    const parsed = moment(value, ['YYYY-MM-DDTHH:mm', 'YYYY-MM-DDTHH:mm:ss', 'YYYY-MM-DD HH:mm:ss', 'YYYY-MM-DD HH:mm', 'YYYY-MM-DD', 'DD/MM/YYYY HH:mm', 'DD/MM/YYYY', moment.ISO_8601], true);
    setDateValue(parsed.isValid() ? parsed.toDate() : null);
  }, [value]);

  // Mientras se escribe a mano llegan fechas incompletas: solo se guarda una fecha completa y con año de 4 cifras
  const handleDateChange = date => {
    setDateValue(date);
    if (date === null) return updateFormData(remoteName, '');
    if (!isNaN(date.getTime()) && date.getFullYear() >= 1900) {
      updateFormData(remoteName, moment(date).format(outputFormat));
    }
  }

  const updateFormData = (remoteName, value) => {
    let editingFieldData = formData.editingFieldData;
    setFormData({...formData, [remoteName]: value, editingFieldData: {...editingFieldData, value: value}});
  }

  const handleSubmit = (event) => {
    event && event.preventDefault();
    // Con Enter en el campo también se envía: no repetir la petición mientras está en curso
    if (isSubmitting) return;
    setIsSubmitting(true);

    updateCandidature(formData, client, phase ? MODULES.ID_ON_BOARDING : MODULES.ID_TALENT_ACQUISITION).then(res => {
      setValue(res[remoteName]);
      setIsSubmitting(false);
      if (job_offer_application_id) {
        manageQueriesWithPrefix([`${QUERY_KEYS.PERSON}:${slug}`], QUERY_ACTIONS.REFETCH);
        handleClosePopup();
      } else {
        updateProfileField(profile, remoteName, res[remoteName], phase);
        handleClosePopup();
        if (module === MODULES.ID_TALENT_ACQUISITION) {
          refetchQueriesByKeys([
            `${module}:${QUERY_KEYS.INBOX}`,
            `${module}:${QUERY_KEYS.OBSERVATIONS}:${profile.id}`,
            `${module}:${QUERY_KEYS.PROFILE}:${profile.id}`
          ]);
        }
      }

    }).catch(() => {
      setIsSubmitting(false);
      toast.error(i18n.boxEditableInfo.error);
    });
  }

  const formattedValue = (value) => {
    if (_.isString(value) && (
      moment(value, 'YYYY-MM-DDTHH:mm:ss.sssZ', true).isValid() ||
      moment(value, 'YYYY-MM-DDTHH:mm:ssZ', true).isValid() || 
      moment(value, 'YYYY-MM-DD', true).isValid() 
    )) {
      return moment(value).format('DD/MM/YYYY');
    } else if (_.isString(value) && isJSON(value)) {
      return jsonToShow(value);
    } else if (!_.isArray(value) && !_.isObject(value)) {
      return value;
    }
  }

  return (<>
    {value ? formattedValue(value) : (value == null && (defaultValue || defaultValue === 0) ? formattedValue(defaultValue) : i18n.editFieldAction.empty)}
    {isEditable && allowEdit ?
      <>
        <button style={{backgroundColor: "transparent", border: "none", cursor: "pointer", verticalAlign: "middle"}} onClick={handleOpenPopup}>
          <PencilLine size={16} color={clientColor}/>
        </button>
        <ActionDialog
          open={showPopup}
          title={i18n.editFieldAction.title}
          onClose={handleClosePopup}
          onConfirm={handleSubmit}
          cancelLabel={i18n.boxEditableInfo.cancel}
          confirmLabel={i18n.boxEditableInfo.accept}
          isPending={isSubmitting}
          disableBackdropClose
        >
          <ModalStyled>
            <form onSubmit={handleSubmit}>
              <p className={'title-field'} dangerouslySetInnerHTML={{ __html: fieldLabel }}></p>
              {options.length > 0 ?
                <Select
                  key={remoteName}
                  defaultValue={_.find(options, {value: value})}
                  isMulti={false}
                  options={options}
                  isClearable={false}
                  isDisabled={isSubmitting}
                  placeholder={i18n.modalFilter.select}
                  styles={veloraSelectStyles(clientColor)}
                  components={veloraSelectComponents}
                  menuPortalTarget={document.body}
                  onChange={val=> {updateFormData(remoteName, val.value)}}
                />
                : ['date', 'datetime-local'].includes(getInputType(remoteName)) ?
                  // Selector de MUI como en el resto de la app: el input nativo dejaba escribir el año
                  // con dos cifras y guardaba 0026. Al back llega en el mismo formato que antes.
                  <MuiPickersUtilsProvider utils={DateFnsUtils} locale={esLocale}>
                    {React.createElement(isDateTimeField ? KeyboardDateTimePicker : KeyboardDatePicker, {
                      key: remoteName,
                      autoOk: !isDateTimeField,
                      ampm: isDateTimeField ? false : undefined,
                      disableToolbar: !isDateTimeField,
                      fullWidth: true,
                      variant: 'inline',
                      inputVariant: 'outlined',
                      format: isDateTimeField ? 'dd/MM/yyyy HH:mm' : 'dd/MM/yyyy',
                      minDate: new Date(1900, 0, 1),
                      invalidDateMessage: isDateTimeField ? i18n.editFieldAction.invalidDateTime : i18n.editFieldAction.invalidDate,
                      minDateMessage: isDateTimeField ? i18n.editFieldAction.invalidDateTime : i18n.editFieldAction.invalidDate,
                      value: dateValue,
                      disabled: isSubmitting,
                      keyboardIcon: <Calendar size={18} color={tokens.color.text.tertiary} />,
                      KeyboardButtonProps: { size: 'small' },
                      onChange: handleDateChange,
                    })}
                  </MuiPickersUtilsProvider>
                : <TextField
                    type={getInputType(remoteName)}
                    key={remoteName}
                    variant="outlined"
                    fullWidth
                    defaultValue={value}
                    disabled={isSubmitting}
                    onChange={target=> {updateFormData(remoteName, target.target.value)}}
                    onKeyDown={(e) => {
                      if (e.key === 'Enter') {
                        e.preventDefault();
                        handleSubmit();
                      }
                    }}
                  />
              }
            </form>
          </ModalStyled>
        </ActionDialog>
      </>
      : null}
  </>)
}

EditFieldAction.propTypes = {
  remoteName: PropTypes.string,
  defaultValue: PropTypes.any,
}

export default EditFieldAction
